import { render, staticRenderFns } from "./savetree.vue?vue&type=template&id=45f45105&scoped=true&"
import script from "./savetree.vue?vue&type=script&lang=js&"
export * from "./savetree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f45105",
  null
  
)

export default component.exports